function BelowFoldAddToCartUpdateProduct()
{
  //console.log("BelowFoldAddToCartUpdateProduct");

  var variantOptionValues = document.querySelectorAll('variant-radios .nw-pdp-option-output-legend-value');

  var parentContainer = document.querySelector('.nw-pdp-below-fold-v3-addToCart-currentOptions-list');

  var outputText = "";
  
  for (var i = 0; i < variantOptionValues.length; i++) 
  {
    var nextVariantOptionValue = variantOptionValues[i];
    if(nextVariantOptionValue.style.display == 'none')
      continue;
    //console.log('nextVariantOptionValue.style.display = ' + nextVariantOptionValue.style.display);
    //console.log('nextVariantOptionValue = ' + nextVariantOptionValue.textContent);
    outputText = outputText + '<div class="nw-pdp-below-fold-v3-addToCart-currentOptionItem">'+nextVariantOptionValue.textContent+'</div>';
  }


  var subscriptionOptions = document.querySelector('.product__info-wrapper .subscriptionActivationOptions');

  if(subscriptionOptions != null)
  {
    //console.log('has subscription options');
    var subscriptionRadioElement = document.querySelector('.product__info-wrapper #optionSubscribe');
    if(subscriptionRadioElement.checked)
    {
      //console.log('subscriptionRadioElement checked');
      var deliveryOptionSelected = document.querySelector('.product__info-wrapper #SubscriptionOptions');
      var deliveryOptionText = deliveryOptionSelected.options[deliveryOptionSelected.selectedIndex].text;
      //console.log('deliveryOptionText = ' + deliveryOptionText);
      outputText = outputText + '<div class="nw-pdp-below-fold-v3-addToCart-currentOptionItem">'+deliveryOptionText+'</div>';
    }
  }

  var addToCartButtonState = document.querySelector('.product-form__buy-button button').getAttribute('disabled');
  if(addToCartButtonState == 'disabled')
  {
    var buttonText = document.querySelector('.product-form__buy-button button span').textContent;
    //console.log('add to cart disabled | button text = ' + buttonText);
    var belowFoldAddToCart = document.querySelector('.nw-pdp-below-fold-v3-addToCart-addbutton');
    //console.log('below fold button = ' + belowFoldAddToCart.textContent);
    if(buttonText.trim().toLowerCase() == 'out of stock')
    {
      belowFoldAddToCart.setAttribute('disabled', 'disabled');
      belowFoldAddToCart.textContent = "Out of stock";
    }
  }
  
  parentContainer.innerHTML = outputText;
}

function BelowFoldAddToCartClick()
{
  var formSubmitMain = document.querySelector('.product-form__buy-button button');

  formSubmitMain.click();
}

function BelowFoldUpdateOptionsClick()
{
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0; 
}


function BelowFoldAddToCartLayout()
{
  var belowFoldAddToCartElement = document.body.querySelector(".nw-pdp-below-fold-v3-addToCart-outer");
  var belowFoldAddToCartElementSpacer = document.body.querySelector(".nw-pdp-below-fold-v3-addToCart-spacer");
  var belowFoldStartRectData = document.body.querySelector(".nw-pdp-below-fold-v3-startMarker").getBoundingClientRect();
  //console.log("belowFoldStartRectData.top" + belowFoldStartRectData.top);
  if(belowFoldStartRectData.top <= 0)
  {
    belowFoldAddToCartElement.style.top = "0";
    belowFoldAddToCartElement.style.left = "0";
    belowFoldAddToCartElement.style.position = "fixed";
    belowFoldAddToCartElementSpacer.style.display = "block";
  }
  else
  {
    belowFoldAddToCartElement.style.position = "relative";
    belowFoldAddToCartElementSpacer.style.display = "none";
  }
}

addEventListener("DOMContentLoaded", (event) => {
  //window.addEventListener('resize', BelowFoldAddToCartLayout);
  window.addEventListener('scroll', BelowFoldAddToCartLayout);
  BelowFoldAddToCartUpdateProduct();
  
});